import React from "react";

const WhyToPartnerWithUs = () => {
    return (
        <div style={{ backgroundColor: "#fff" }}>

            <div className="container pt-5 pb-5" style={{ width: "100%" }}>
                <div className="d-flex flex-column justify-content-center align-item-center ">
                    <div
                        className="d-flex justify-content-center align-item-center"
                        style={{ color: "#1f2c6a" }}
                    >
                        <h2> <strong>Why Partner With Buy Policy Now</strong> </h2>
                    </div>
                    <div className="main-whyPartner-card mt-3">
                        <div class="notification">
                            <div class="notiglow"></div>
                            <div class="notiborderglow"></div>
                            <div class="notititle">Strong Brand Reputation</div>
                            <div class="notibody">Partner with a trusted industry leader.</div>
                        </div>
                        <div class="notification">
                            <div class="notiglow"></div>
                            <div class="notiborderglow"></div>
                            <div class="notititle">User-Friendly Platform</div>
                            <div class="notibody">Navigate our platform with ease and efficiency.</div>
                        </div>
                        <div class="notification">
                            <div class="notiglow"></div>
                            <div class="notiborderglow"></div>
                            <div class="notititle">Attractive Commission Structure</div>
                            <div class="notibody">Earn competitive commissions with every sales.</div>
                        </div>
                        <div class="notification">
                            <div class="notiglow"></div>
                            <div class="notiborderglow"></div>
                            <div class="notititle">Easy Onboarding Process</div>
                            <div class="notibody">Seamlessly integrate into our PoSP program.</div>
                        </div>
                        <div class="notification">
                            <div class="notiglow"></div>
                            <div class="notiborderglow"></div>
                            <div class="notititle">Cutting-Edge Technology</div>
                            <div class="notibody">Utilize our advanced AI-driven platform for seamless transactions.</div>
                        </div>
                        <div class="notification">
                            <div class="notiglow"></div>
                            <div class="notiborderglow"></div>
                            <div class="notititle">Flexible Work Opportunities</div>
                            <div class="notibody">Choose your own hours and work from anywhere.</div>
                        </div>
                        <div class="notification">
                            <div class="notiglow"></div>
                            <div class="notiborderglow"></div>
                            <div class="notititle">Diverse Insurance Portfolio</div>
                            <div class="notibody">Sell a range of policies: car, bike, health and more.</div>
                        </div>

                        {/* <div className="whyPartner-card">
                            <h5>Work directly with Buy Policy</h5>
                            <p>
                                Get a chance to work with Asia's General Insurance Company of the
                                Year 2019.
                            </p>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyToPartnerWithUs;
